import {
  OR_REQUEST_SUGGESTED_ORDER,
  OR_RECEIVE_SUGGESTED_ORDER,
  OR_RECEIVE_SUGGESTED_ORDER_ERROR,
  OR_SHOW_MORE_SUGGESTED_ORDER_FOPS,
  OR_SO_FREQUENCY_FILTER_UPDATE,
  OR_SO_CATEGORY_FILTER_UPDATE,
  OR_REQUEST_SO_FREQUENCY_UPDATE,
  OR_SO_FREQUENCY_UPDATE_SUCCESS,
  OR_SO_FREQUENCY_UPDATE_ERROR,
} from '../../actions/management/suggestedOrder';
import { SHOW_MORE_FOPS, INITIAL_MAX_DISPLAY_FOPS } from 'apps/catalogue/actions/catalogue';
import { SuggestedOrderFrequency } from '../../types';

function updateFopFrequency(suggestedOrderSection, sku, frequency) {
  if (!suggestedOrderSection) {
    return suggestedOrderSection;
  }
  const fop = suggestedOrderSection.fops.find(f => f.sku === sku);

  if (!fop) {
    return suggestedOrderSection;
  }

  const fopIdx = suggestedOrderSection.fops.indexOf(fop);
  const newFop = {
    ...fop,
    fopAttributes: {
      ...fop.fopAttributes,
      suggested_order_item_type: frequency,
    },
  };
  const newFops = suggestedOrderSection.fops.slice();
  newFops[fopIdx] = newFop;
  return {
    ...suggestedOrderSection,
    fops: newFops,
  };
}

export const initialState = {
  suggestedOrderSection: null,
  isFetchingSuggestedOrder: false,
  isFetchingSuggestedOrderError: false,
  maxDisplayFops: INITIAL_MAX_DISPLAY_FOPS,
  frequencyFilter: SuggestedOrderFrequency.ALL,
  categoryFilter: null,
  frequencyUpdatingSkus: [],
};

export default function suggestedOrderReducer(state = initialState, action) {
  switch (action.type) {
    case OR_REQUEST_SUGGESTED_ORDER:
      return { ...state, isFetchingSuggestedOrder: true };
    case OR_RECEIVE_SUGGESTED_ORDER:
      return {
        ...state,
        suggestedOrderSection: action.suggestedOrderSection,
        isFetchingSuggestedOrder: false,
        isFetchingSuggestedOrderError: false,
        maxDisplayFops: INITIAL_MAX_DISPLAY_FOPS,
      };
    case OR_RECEIVE_SUGGESTED_ORDER_ERROR:
      return {
        ...state,
        isFetchingSuggestedOrder: false,
        isFetchingSuggestedOrderError: true,
      };
    case OR_SHOW_MORE_SUGGESTED_ORDER_FOPS:
      return { ...state, maxDisplayFops: state.maxDisplayFops + SHOW_MORE_FOPS };
    case OR_SO_FREQUENCY_FILTER_UPDATE:
      return {
        ...state,
        frequencyFilter: action.frequency,
        categoryFilter: null,
      };
    case OR_SO_CATEGORY_FILTER_UPDATE:
      return { ...state, categoryFilter: action.categoryId };
    case OR_REQUEST_SO_FREQUENCY_UPDATE: {
      if (state.frequencyUpdatingSkus.includes(action.sku)) {
        return state;
      }
      const newFrequencyUpdatingSkus = state.frequencyUpdatingSkus.concat(action.sku);
      return { ...state, frequencyUpdatingSkus: newFrequencyUpdatingSkus };
    }
    case OR_SO_FREQUENCY_UPDATE_SUCCESS:
      return {
        ...state,
        suggestedOrderSection: updateFopFrequency(state.suggestedOrderSection, action.sku, action.frequency),
        frequencyUpdatingSkus: state.frequencyUpdatingSkus.filter(e => e !== action.sku),
      };
    case OR_SO_FREQUENCY_UPDATE_ERROR:
      return {
        ...state,
        frequencyUpdatingSkus: state.frequencyUpdatingSkus.filter(e => e !== action.sku),
      };
    default:
      return state;
  }
}
